const HTTP_PROTOCOL_HTTPS: string = 'https://';

export default HTTP_PROTOCOL_HTTPS;
